import api from "../../../services/api";

export const editUserGroups = async (params: {
  username: string;
  groups_to_add: string[];
  groups_to_remove: string[];
}) => {
  const { username, ...payload } = params;
  const { data } = await api.put(`/api/cognito/admin/users/${encodeURIComponent(username)}/groups`, {
    username,
    ...payload,
  });
  return data;
};